import {
    registeredApi,
    getYzmApi,
    loginApi,
    forgetPassApi
} from '../../network/api'
const data = function () {
    return {
        title: '注册',
        codetext: '获取验证码',
        logo: '',
        code: '',
        pass2: '',
        // email: '1352648568@qq.com',
        // pass: '112233',
        // agree: true,
        email: '',
        pass: '',
        agree: false,
        zhuce: false,
        denglu: true,
        showyhxy: false,
        zhucesucc: false,
        yonghuxieyi: '',
        zhuceorsure: '注册'
    }
};
const computed = {

}
const methods = {
    // 注册 
    registered() {
        if (this.agree == false) {
            this.$message({
                message: '请同意粤成商户中心用户协议！',
                type: 'warning'
            });
            return
        }
        if (this.zhuceorsure == '注册') {
            let formdata = {
                email: this.email,
                pwd: this.pass,
                yzm: this.code,
                re_pwd: this.pass2
            }
            registeredApi(formdata).then(res => {
                console.log(res);

                if (res.data.code == 0) {
                    this.$store.commit("setUserInfo", res.data.data);
                    this.denglu = true
                    this.email = ''
                    this.pass = ''
                    this.code = ''
                    this.pass2 = ''
                    this.zhucesucc = true
                    setTimeout(() => {
                        this.$router.push({
                            path: '/perfect',
                        })
                    }, 3000);
                    // this.$message({
                    //     message: res.data.msg,
                    //     type: 'success'
                    // });
                } else {
                    this.$message({
                        message: res.data.msg,
                    });
                }
            }).catch()
        }
        // 点击忘记密码后重置密码
        if (this.zhuceorsure == '确定') {
            let formdata = {
                email: this.email,
                pwd: this.pass,
                yzm: this.code,
                re_pwd: this.pass2
            }
            forgetPassApi(formdata).then(res => {
                console.log(res);
                if (res.data.code == 1) {
                    this.denglu = true
                    this.zhuce = false
                    this.email = ''
                    this.pass = ''
                    this.code = ''
                    this.pass2 = ''
                    this.agree = false
                    this.$message({
                        message: res.data.msg,
                        type: 'success'
                    });
                } else {
                    this.$message({
                        message: res.data.msg,
                    });
                }
            }).catch()
        }

    },
    // 注册完立即去登录
    gonow() {
        this.$router.push({
            path: '/perfect',

        })
    },
    // 登录
    login() {
        if (this.agree) {
            let formdata = {
                email: this.email,
                pwd: this.pass,
            }
            loginApi(formdata).then(res => {
                console.log(res);
                if (res.data.code == 0) {
                    this.$store.commit("setUserInfo", res.data.data);
                    // this.$message({
                    //     message: res.data.msg,
                    //     type: 'success'
                    // });
                    this.$router.push({
                        path: '/perfect',

                    })
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'warning'
                    });
                }
            }).catch()
        } else {
            this.$message({
                message: '请同意粤成商户中心用户协议！',
                type: 'warning'
            });
        }
    },
    // 使用已有账号登录
    gologin() {
        this.denglu = true
        this.zhuce = false
        this.email = ''
        this.pass = ''
    },
    // 去注册页面
    goregistered() {

        this.denglu = false
        this.zhuce = true
        this.email = ''
        this.pass = ''
        this.title = '注册'
        this.zhuceorsure = '注册'

    },
    // 去忘记密码页面
    forgetpass() {
        this.denglu = false
        this.zhuce = true
        this.title = '重置密码'
        this.zhuceorsure = '确定'
    },
    // 获取验证码
    getcode() {
        getYzmApi(this.email).then(res => {
            console.log(res);
            if (res.data.code == 0) {
                let time = 60;
                var timer = ''
                if (this.codetext === '获取验证码') {

                    timer = setInterval(() => {
                        this.codetext = time-- + 's'
                        if (time == -2) {
                            clearInterval(timer)
                            this.codetext = '获取验证码';
                            return
                        }
                    }, 1000);

                }
            }
            this.$message(res.data.msg);
        }).catch()

    },
    // 用户协议的显示
    isshowyhxy() {

        this.showyhxy = false
        if (this.logo == 0) {
            this.zhuce = true

        }
        if (this.logo == 1) {
            this.denglu = true

        }


    }

};


export default {
    data,
    computed,
    methods,
}